export default __webpack_public_path__ + "static/darkVector-60ab1beb0ef342060abf32a7a19be4e2.webp";